import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Popconfirm, Space } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

import type { ColumnsType } from 'antd/es/table';
import type { IPushNotification } from './types';

import { routes } from '@/app/router/routes';

import { usePushNotificationDelete } from './queries';

export const useColumns = (): ColumnsType<IPushNotification> => {
  const { t } = useTranslation();
  const { mutate: pushNotificationDelete } = usePushNotificationDelete();

  return [
    {
      title: t('pushNotifications.namePL'),
      dataIndex: 'namePl',
      key: 'namePl',
    },
    {
      title: t('pushNotifications.nameEN'),
      dataIndex: 'nameEn',
      key: 'nameEn',
    },
    {
      title: '',
      key: 'actions',
      align: 'center' as const,
      render: (text: IPushNotification) => (
        <Space>
          <Link to={routes.pushNotificationUpdate(text.id)}>
            <Button>
              <EditOutlined />
            </Button>
          </Link>
          <Popconfirm
            title={t('pushNotifications.delete.title')}
            okText={t('pushNotifications.delete.okText')}
            cancelText={t('pushNotifications.delete.cancelText')}
            placement='left'
            onConfirm={() => pushNotificationDelete(text.id)}
          >
            <Button>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
};
